module.exports = __webpack_public_path__ + "img/truewallet.927689dd.png";